export default "__VITE_ASSET__BtXBDz43__"